export default{layoutManager:"w_Fu",bottomCenter:"w_Fv",hasNubbin:"w_Fw",bottomLeft:"w_Fx",bottomRight:"w_Fy",left:"w_Fz",right:"w_F0",topCenter:"w_F1",topLeft:"w_F2",topRight:"w_F3"};
